export enum SECTION_NAMES {
  // new
  BLOG_AUTHOR = 'blog-author',
  BREADCRUMBS = 'breadcrumbs',
  SIDE_BANNER = 'side-banner',
  SIDE_NAVIGATION = 'side-navigation',
  HERO_WITH_BACKGROUND_IMAGE = 'hero-with-background-image',
  FOOTER_BANNER = 'footer-banner',
  IMAGE_ACCORDIONS = 'image-accordions',
  CARDS_WITH_HEADER = 'cards-with-header',
  CODE_BLOCK = 'code-block',
  TEXT_BLOCK = 'text-block',
  CTA_BLOCK = 'cta-block',
  TEXT_IMAGE = 'text-image',
  SOCIAL_PROOF = 'social-proof',
  HERO_WITH_SEARCH = 'hero-with-search',
  OPEN_POSITIONS_LIST = 'open-positions-list',
  JOB_APPLICATION_FORM = 'job-application-form',
  LOGO_CAROUSEL = 'logo-carousel',
  RECOMMENDATION_CARDS = 'recommendation-cards',
  SCRAPER_PLAYGROUND = 'scraper',
  WHAT_IS_MY_IP = 'what-is-my-ip',
  IMAGE_BLOCK = 'image-block',
  CAROUSEL_BLOCK = 'carousel-block',
  ARTICLES_FEED = 'articles-feed',
  AUTHOR = 'author',
  RELATED_ARTICLES = 'related-articles',
  TEXT_GRID = 'text-grid',
  PRODUCT_CARDS = 'product-cards',
  BLOG_OVERVIEW = 'blog-overview',
  BLOG_METADATA = 'blog-metadata',
  TABLE = 'table',
  FEATURES_BLOCK = 'features-block',
  SCRAPING_TEMPLATE_LIBRARY = 'scraping-template-library',
  SCRAPING_TEMPLATE_PREVIEW = 'scraping-template-preview',
  CONTACT_SALES = 'contact-sales',
  QUOTE = 'quote',
  BANNER = 'banner',
  COMPARISON_TABLE = 'comparison-table',
  VIDEO_ACCORDION = 'video-accordion',
  TOP_BANNER = 'top-banner',
  LEAD_COLLECTION_FORM = 'lead-collection-form',
  WHISTLEBLOWER_FORM = 'whistleblower-form',
  FEATURES_NUMBERS_BLOCK = 'features-numbers-block',
  TIMELINES_BLOCK = 'timelines-block',
  TEAM_MEMBERS_BLOCK = 'team-members-block',
  MEMBERS_CAROUSEL_BLOCK = 'members-carousel-block',
  PRICING_SECTION = 'pricing-section',
  BIG_MARKER = 'big-marker',
  ERROR_PAGE = 'error-page',
  MODAL = 'modal',
  VIDEO_POPUP = 'video-popup',
  HEADER_MENU = 'header-menu',
  GATED_CONTENT = 'gated-content',
  MENU_CAROUSEL = 'menu-carousel',
  MENU_GROUP = 'menu-group',
  HOMEPAGE_CAROUSEL = 'homepage-carousel',
  HOMEPAGE_HERO = 'homepage-hero',
  AI_SOLUTION_HERO = 'ai-solution-hero',
  BENTO_FEATURE_BLOCK = 'bento-feature-block',
  BENTO_IMAGE_CAROUSEL = 'bento-image-carousel',
  WELCOME_POP_UP = 'welcome-pop-up',
  GLOBAL_TEXT_MODAL = 'global-text-modal',
  CONTENT_HIGHLIGHTS_SECTION = 'content-highlights-section',
  INFO_SECTIONS_WITH_SIDE_IMAGE_TITLE = 'info-sections-with-side-image-title',
  INFO_CARDS_WITH_SIDE_IMAGE_TITLE = 'info-cards-with-side-image-title',
  // old but still used
  HERO = 'hero',
  PRICING_CARDS = 'pricing-cards',
  PRICING_TABLE = 'pricing-table',
  FAQ = 'faq',
  SIMPLE_CARDS = 'simple-cards',
  FOOTER = 'footer',
  BENTO_LABELED_ICON_CARDS = 'bento-labeled-icon-cards',
  BENTO_FOOTER = 'bento-footer',
  VIDEO_BLOCK = 'video-block',
  HERO_FEATURES = 'hero-3-usp-columns-homepage',

  // old
  LOCATION_FLAGS = 'location-flags',

  BENTO_BANNER = 'bento-banner',
  BENTO_ICON_LINK_CARDS = 'bento-icon-link-cards',
  USE_CASES = 'use-cases',
  TRUSTPILOT_REVIEWS = 'trustpilot-reviews',
  TEXT_IMAGE_COLUMNS = 'text-image-columns',
  TEXT_IMAGE_CTA = 'text-image-cta',
  IMAGE_TEXT_COLUMN = 'image-text-column',
  PRICING_SLIDER = 'pricing-slider',
  BADGES = 'badges',
  PAYMENT_METHOD = 'payment-method',

  HERO_LOGOS = 'hero-recognized-by-homepage',
  WEBINAR_REGISTRATION_FORM = 'webinar-registration-form',
  BIGGER_PLANS = 'bigger-plans-banner',
  TESTIMONIALS = 'testimonials',

  SCRAPING_HERO = 'scraping-hero',
  PROXY_PLAYGROUND = 'proxy-playground',
  BENTO_AWARDS = 'bento-awards',
  BENTO_FEATURE_CARDS = 'bento-feature-cards-section',
  BENTO_FEATURE_AND_CLICKABLE_CARDS = 'bento-feature-and-clickable-cards-section',
  BENTO_FEATURE_AND_PRODUCT_CARDS = 'bento-feature-and-product-cards-section',
  BENTO_BLOG_HIGHLIGHTS = 'bento-blog-highlights',
  BENTO_PRICING_CARDS = 'bento-pricing-cards-section',
  SCRAPING_PLAYGROUND = 'scraping-playground',
}
